import { Currency } from '@commenda/prisma';
import { TCurrencyInfo } from '@commenda/types/src/random';
import { Convert } from 'easy-currencies';

export class CurrencyHelper {
  static readonly currencyList = {
    [Currency.CVE]: {
      locale: 'pt-CV',
      name: 'CVE',
      style: 'CVE',
      currency: Currency.CVE,
    },
    [Currency.USD]: {
      locale: 'en-US',
      name: 'USD',
      style: '$',
      currency: Currency.USD,
    },
    [Currency.CAD]: {
      locale: 'en-CA',
      name: 'CAD',
      style: '$',
      currency: Currency.CAD,
    },
    [Currency.MXN]: {
      locale: 'es-MX',
      name: 'MXN',
      style: '$',
      currency: Currency.MXN,
    },

    // South America
    [Currency.BRL]: {
      locale: 'pt-BR',
      name: 'BRL',
      style: 'R$',
      currency: Currency.BRL,
    },
    [Currency.ARS]: {
      locale: 'es-AR',
      name: 'ARS',
      style: '$',
      currency: Currency.ARS,
    },
    [Currency.CLP]: {
      locale: 'es-CL',
      name: 'CLP',
      style: '$',
      currency: Currency.CLP,
    },
    [Currency.COP]: {
      locale: 'es-CO',
      name: 'COP',
      style: '$',
      currency: Currency.COP,
    },
    [Currency.PEN]: {
      locale: 'es-PE',
      name: 'PEN',
      style: 'S/',
      currency: Currency.PEN,
    },
    [Currency.UYU]: {
      locale: 'es-UY',
      name: 'UYU',
      style: '$',
      currency: Currency.UYU,
    },

    // Europe
    [Currency.EUR]: {
      locale: 'en-EU',
      name: 'EUR',
      style: '€',
      currency: Currency.EUR,
    },
    [Currency.GBP]: {
      locale: 'en-GB',
      name: 'GBP',
      style: '£',
      currency: Currency.GBP,
    },
    [Currency.CHF]: {
      locale: 'en-CH',
      name: 'CHF',
      style: 'CHF',
      currency: Currency.CHF,
    },
    [Currency.PLN]: {
      locale: 'pl-PL',
      name: 'PLN',
      style: 'zł',
      currency: Currency.PLN,
    },
    [Currency.CZK]: {
      locale: 'cs-CZ',
      name: 'CZK',
      style: 'Kč',
      currency: Currency.CZK,
    },
    [Currency.HUF]: {
      locale: 'hu-HU',
      name: 'HUF',
      style: 'Ft',
      currency: Currency.HUF,
    },
    [Currency.DKK]: {
      locale: 'da-DK',
      name: 'DKK',
      style: 'kr',
      currency: Currency.DKK,
    },
    [Currency.NOK]: {
      locale: 'nb-NO',
      name: 'NOK',
      style: 'kr',
      currency: Currency.NOK,
    },
    [Currency.SEK]: {
      locale: 'sv-SE',
      name: 'SEK',
      style: 'kr',
      currency: Currency.SEK,
    },
    [Currency.BGN]: {
      locale: 'bg-BG',
      name: 'BGN',
      style: 'лв',
      currency: Currency.BGN,
    },
    [Currency.RON]: {
      locale: 'ro-RO',
      name: 'RON',
      style: 'lei',
      currency: Currency.RON,
    },
    [Currency.HRK]: {
      locale: 'hr-HR',
      name: 'HRK',
      style: 'kn',
      currency: Currency.HRK,
    },

    // East Asia
    [Currency.CNY]: {
      locale: 'zh-CN',
      name: 'CNY',
      style: '¥',
      currency: Currency.CNY,
    },
    [Currency.JPY]: {
      locale: 'ja-JP',
      name: 'JPY',
      style: '¥',
      currency: Currency.JPY,
    },
    [Currency.KRW]: {
      locale: 'ko-KR',
      name: 'KRW',
      style: '₩',
      currency: Currency.KRW,
    },
    [Currency.TWD]: {
      locale: 'zh-TW',
      name: 'TWD',
      style: 'NT$',
      currency: Currency.TWD,
    },
    [Currency.MNT]: {
      locale: 'mn-MN',
      name: 'MNT',
      style: '₮',
      currency: Currency.MNT,
    },

    // Southeast Asia
    [Currency.SGD]: {
      locale: 'en-SG',
      name: 'SGD',
      style: 'S$',
      currency: Currency.SGD,
    },
    [Currency.THB]: {
      locale: 'th-TH',
      name: 'THB',
      style: '฿',
      currency: Currency.THB,
    },
    [Currency.VND]: {
      locale: 'vi-VN',
      name: 'VND',
      style: '₫',
      currency: Currency.VND,
    },
    [Currency.IDR]: {
      locale: 'id-ID',
      name: 'IDR',
      style: 'Rp',
      currency: Currency.IDR,
    },
    [Currency.MYR]: {
      locale: 'ms-MY',
      name: 'MYR',
      style: 'RM',
      currency: Currency.MYR,
    },
    [Currency.MMK]: {
      locale: 'my-MM',
      name: 'MMK',
      style: 'K',
      currency: Currency.MMK,
    },
    [Currency.KHR]: {
      locale: 'km-KH',
      name: 'KHR',
      style: '៛',
      currency: Currency.KHR,
    },
    [Currency.LAK]: {
      locale: 'lo-LA',
      name: 'LAK',
      style: '₭',
      currency: Currency.LAK,
    },
    [Currency.PHP]: {
      locale: 'fil-PH',
      name: 'PHP',
      style: '₱',
      currency: Currency.PHP,
    },

    // South Asia
    [Currency.INR]: {
      locale: 'en-IN',
      name: 'INR',
      style: '₹',
      currency: Currency.INR,
    },
    [Currency.BDT]: {
      locale: 'bn-BD',
      name: 'BDT',
      style: '৳',
      currency: Currency.BDT,
    },
    [Currency.LKR]: {
      locale: 'si-LK',
      name: 'LKR',
      style: 'Rs',
      currency: Currency.LKR,
    },
    [Currency.NPR]: {
      locale: 'ne-NP',
      name: 'NPR',
      style: 'Rs',
      currency: Currency.NPR,
    },
    [Currency.PKR]: {
      locale: 'ur-PK',
      name: 'PKR',
      style: 'Rs',
      currency: Currency.PKR,
    },

    // Middle East
    [Currency.AED]: {
      locale: 'ar-AE',
      name: 'AED',
      style: 'د.إ',
      currency: Currency.AED,
    },
    [Currency.SAR]: {
      locale: 'ar-SA',
      name: 'SAR',
      style: '﷼',
      currency: Currency.SAR,
    },
    [Currency.ILS]: {
      locale: 'he-IL',
      name: 'ILS',
      style: '₪',
      currency: Currency.ILS,
    },
    [Currency.QAR]: {
      locale: 'ar-QA',
      name: 'QAR',
      style: 'ر.ق',
      currency: Currency.QAR,
    },
    [Currency.BHD]: {
      locale: 'ar-BH',
      name: 'BHD',
      style: '.د.ب',
      currency: Currency.BHD,
    },
    [Currency.KWD]: {
      locale: 'ar-KW',
      name: 'KWD',
      style: 'د.ك',
      currency: Currency.KWD,
    },
    [Currency.OMR]: {
      locale: 'ar-OM',
      name: 'OMR',
      style: 'ر.ع.',
      currency: Currency.OMR,
    },
    [Currency.IRR]: {
      locale: 'fa-IR',
      name: 'IRR',
      style: '﷼',
      currency: Currency.IRR,
    },

    // Oceania
    [Currency.AUD]: {
      locale: 'en-AU',
      name: 'AUD',
      style: '$',
      currency: Currency.AUD,
    },
    [Currency.NZD]: {
      locale: 'en-NZ',
      name: 'NZD',
      style: '$',
      currency: Currency.NZD,
    },
    [Currency.FJD]: {
      locale: 'en-FJ',
      name: 'FJD',
      style: '$',
      currency: Currency.FJD,
    },

    // Africa
    [Currency.ZAR]: {
      locale: 'en-ZA',
      name: 'ZAR',
      style: 'R',
      currency: Currency.ZAR,
    },
    [Currency.EGP]: {
      locale: 'ar-EG',
      name: 'EGP',
      style: 'E£',
      currency: Currency.EGP,
    },
    [Currency.NGN]: {
      locale: 'en-NG',
      name: 'NGN',
      style: '₦',
      currency: Currency.NGN,
    },
    [Currency.MAD]: {
      locale: 'fr-MA',
      name: 'MAD',
      style: 'د.م.',
      currency: Currency.MAD,
    },
    [Currency.KES]: {
      locale: 'en-KE',
      name: 'KES',
      style: 'KSh',
      currency: Currency.KES,
    },
    [Currency.TND]: {
      locale: 'fr-TN',
      name: 'TND',
      style: 'د.ت',
      currency: Currency.TND,
    },
    [Currency.GHS]: {
      locale: 'en-GH',
      name: 'GHS',
      style: 'GH₵',
      currency: Currency.GHS,
    },
    [Currency.LUF]: {
      name: 'LUF',
      style: 'LUF',
      locale: 'en-LU',
      currency: Currency.LUF,
    },
    [Currency.UGX]: {
      name: 'UGX',
      style: 'UGX',
      locale: 'en-UG',
      currency: Currency.UGX,
    },
    [Currency.RSD]: {
      name: 'RSD',
      style: 'RSD',
      locale: 'en-RS',
      currency: Currency.RSD,
    },
    [Currency.INVALID_DEFAULT_VALUE]: undefined,
  };

  static DEFAULT_CURRENCY_INFO: TCurrencyInfo = this.currencyList[Currency.USD];

  static getCurrencyInfo(currency: Currency): TCurrencyInfo {
    return this.currencyList[currency];
  }

  static formatCurrency(
    currency: Currency,
    amount: number,
    options?: {
      minimumFractionDigits?: number;
      maximumFractionDigits?: number;
    }
  ) {
    const currencyInfo = this.getCurrencyInfo(currency);
    if (!currencyInfo) {
      throw new Error(`Currency ${currency} not found`);
    }
    return new Intl.NumberFormat(currencyInfo.locale, {
      style: 'currency',
      currency: currencyInfo.currency,
      minimumFractionDigits: options?.minimumFractionDigits || 2,
      maximumFractionDigits: options?.maximumFractionDigits || 2,
    }).format(amount);
  }

  static async convertCurrency(
    fromCurrency: Currency,
    toCurrency: Currency,
    amount: number
  ): Promise<number> {
    try {
      if (fromCurrency === toCurrency) return amount;
      return await Convert(amount).from(fromCurrency).to(toCurrency);
    } catch (error) {
      console.error('Conversion failed:', error);
      return 0;
    }
  }
}
